var sliderThumbs;
var sliderImages;
var gallerySlider;

$(document).on('shopify:section:load', function() {
    if ($('.product').length) {

        if (wSize >= 1280) {
            $('.thumbnail-slider.mobile').remove();
        }
        else {
            $('.thumbnail-slider.desktop').remove();
        }

        sliderThumbs = new Swiper(".thumbnail-slider", {
            direction: "vertical",
            slidesPerView: 7,
            spaceBetween: 10,
            speed: 5000,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    direction: "horizontal"
                },
                1280: {
                    direction: "vertical"
                }
            }
        });

        sliderImages = new Swiper(".main-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            mousewheel: false,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            grabCursor: true,
            thumbs: {
                swiper: sliderThumbs
            }
        });

        gallerySlider = new Swiper(".gallery-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            grabCursor: true,
            watchSlidesProgress: true,
            thumbs: {
                swiper: sliderThumbs,
                swiper: sliderImages
            }
        });
    }

    if ($('.accessories .owl-carousel').length) {
        let owl_accessory = $('.accessories .owl-carousel').owlCarousel({
            items: 1,
            nav: false,
            dots: false,
            smartSpeed: 800,
            margin: 10,
            stagePadding: 50,
            responsive: {
                0: {
                    stagePadding: 0
                },
                1280: {
                    stagePadding: 50
                }
            }
        });
    
        $(".accessories .slide-prev").on('click', function() {
            owl_accessory.trigger('prev.owl.carousel');
        });
        $(".accessories .slide-next").on('click', function() {
            owl_accessory.trigger('next.owl.carousel');
        });
    }

    if ($('.youtube-slider').length) {
        $('.youtube-slider .youtube').each(function() {
            let videoId = $(this).data('yt');
            let thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

            if (!$(this).hasClass('custom-cover')) {
                $(this).css('background-image', `url(${thumbnailUrl})`);
            }            
        });

        const iframes = document.querySelectorAll('.youtube-slider .youtube');
        iframes.forEach((iframe, index) => {
            const videoId = $(iframe).data('yt');
            const apiUrl = `https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`;

            fetch(apiUrl)
                .then(response => response.json())
                .then(data => {
                    const titleElement = document.getElementsByClassName('video-title')[index];
                    const authorNameElement = document.getElementsByClassName('author-name')[index];

                    titleElement.textContent = data.title;
                    authorNameElement.textContent = data.author_name;
                })
                .catch(error => {
                    console.error('Error fetching video details:', error);
                    const titleElement = document.getElementsByClassName('video-title')[index];
                    const authorNameElement = document.getElementsByClassName('author-name')[index];

                    titleElement.textContent = 'Error fetching video title';
                    authorNameElement.textContent = 'Error fetching author name';
                });

            const videoApiUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=AIzaSyAu_MPjsLksQo7Mo9cn1ei1CUFhjDiYKrE`;
                
            $.get(videoApiUrl, function(response) {
                if (response.items.length > 0) {
                    const channelId = response.items[0].snippet.channelId;
                    
                    const channelApiUrl = `https://www.googleapis.com/youtube/v3/channels?part=snippet&id=${channelId}&key=AIzaSyAu_MPjsLksQo7Mo9cn1ei1CUFhjDiYKrE`;
        
                    $.get(channelApiUrl, function(channelResponse) {
                        if (channelResponse.items.length > 0) {
                            const channelAvatar = channelResponse.items[0].snippet.thumbnails.default.url;
                            document.getElementsByClassName('yt-profile')[index].src = channelAvatar;
                        }
                    });
                } else {
                    console.error('Video not found.');
                }
            });
        });

        $('.youtube-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1,
                        dots: false
                    },
                    768: {
                        items: 2,
                        dots: false
                    },
                    1280: {
                        items: 3,
                        dots: false
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });
        });
    }

    if ($('.product-card:not(.tabs):not(.recently-viewed)').length) {
        $('.product-card:not(.tabs):not(.recently-viewed) .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1280: {
                        items: 3
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });
        });
    }

    eachOwl();

    video_bg_text();
    block_text_image();
    image_hotspot();
    middle_banner();
    youtube_slider();
    
});

$(document).ready(function() {
    if ($('.product').length) {

        if (wSize >= 1280) {
            $('.thumbnail-slider.mobile').remove();
        }
        else {
            $('.thumbnail-slider.desktop').remove();
        }

        sliderThumbs = new Swiper(".thumbnail-slider", {
            direction: "vertical",
            slidesPerView: 7,
            spaceBetween: 10,
            speed: 5000,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    direction: "horizontal"
                },
                1280: {
                    direction: "vertical"
                }
            }
        });

        sliderImages = new Swiper(".main-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            mousewheel: false,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            grabCursor: true,
            thumbs: {
                swiper: sliderThumbs
            }
        });

        gallerySlider = new Swiper(".gallery-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            grabCursor: true,
            watchSlidesProgress: true,
            thumbs: {
                swiper: sliderThumbs,
                swiper: sliderImages
            }
        });
    }

    if ($('.accessories .owl-carousel').length) {
        let owl_accessory = $('.accessories .owl-carousel').owlCarousel({
            items: 1,
            nav: false,
            dots: false,
            smartSpeed: 800,
            margin: 10,
            stagePadding: 50,
            responsive: {
                0: {
                    stagePadding: 0
                },
                1280: {
                    stagePadding: 50
                }
            }
        });
    
        $(".accessories .slide-prev").on('click', function() {
            owl_accessory.trigger('prev.owl.carousel');
        });
        $(".accessories .slide-next").on('click', function() {
            owl_accessory.trigger('next.owl.carousel');
        });
    }

    if ($('.youtube-slider').length) {
        $('.youtube-slider .youtube').each(function() {
            let videoId = $(this).data('yt');
            let thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
            if (!$(this).hasClass('custom-cover')) {
                $(this).css('background-image', `url(${thumbnailUrl})`);
            }    
        });

        const iframes = document.querySelectorAll('.youtube-slider .youtube');
        iframes.forEach((iframe, index) => {
            const videoId = $(iframe).data('yt');
            const apiUrl = `https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`;

            fetch(apiUrl)
                .then(response => response.json())
                .then(data => {
                    const titleElement = document.getElementsByClassName('video-title')[index];
                    const authorNameElement = document.getElementsByClassName('author-name')[index];

                    titleElement.textContent = data.title;
                    authorNameElement.textContent = data.author_name;
                })
                .catch(error => {
                    console.error('Error fetching video details:', error);
                    const titleElement = document.getElementsByClassName('video-title')[index];
                    const authorNameElement = document.getElementsByClassName('author-name')[index];

                    titleElement.textContent = 'Error fetching video title';
                    authorNameElement.textContent = 'Error fetching author name';
                });

            const videoApiUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=AIzaSyAu_MPjsLksQo7Mo9cn1ei1CUFhjDiYKrE`;
                
            $.get(videoApiUrl, function(response) {
                if (response.items.length > 0) {
                    const channelId = response.items[0].snippet.channelId;
                    
                    const channelApiUrl = `https://www.googleapis.com/youtube/v3/channels?part=snippet&id=${channelId}&key=AIzaSyAu_MPjsLksQo7Mo9cn1ei1CUFhjDiYKrE`;
        
                    $.get(channelApiUrl, function(channelResponse) {
                        if (channelResponse.items.length > 0) {
                            const channelAvatar = channelResponse.items[0].snippet.thumbnails.default.url;
                            document.getElementsByClassName('yt-profile')[index].src = channelAvatar;
                        }
                    });
                } else {
                    console.error('Video not found.');
                }
            });
        });

        $('.youtube-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1,
                        dots: false
                    },
                    768: {
                        items: 2,
                        dots: false
                    },
                    1280: {
                        items: 3,
                        dots: false
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });
        });
    }

    if ($('.product-card:not(.tabs):not(.recently-viewed)').length) {
        $('.product-card:not(.tabs):not(.recently-viewed) .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 3,
                nav: true,
                dots: false,
                smartSpeed: 800,
                margin: 20,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1280: {
                        items: 3
                    }
                }
            }).on('changed.owl.carousel', function(event) {
                let currentIndex = event.item.index;
                let totalItems = event.item.count;
                let pageSize = event.page.size;

                if (currentIndex === 0) {
                    $floatNav.find('.owl-prev').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-prev').prop('disabled', false);
                }

                if (currentIndex >= totalItems - pageSize) {
                    $floatNav.find('.owl-next').prop('disabled', true);
                } else {
                    $floatNav.find('.owl-next').prop('disabled', false);
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });
        });
    }

    eachOwl();

    video_bg_text();
    block_text_image();
    image_hotspot();
    middle_banner();
    youtube_slider();
    
});

$(window).resize(function() {
    youtube_slider();
});

$(window).scroll(function() {
    productNav();

    bindHotspotEvents();

    video_bg_text();
    block_text_image();
    image_hotspot();
    middle_banner();
});

function eachOwl() {
    $('.owl-carousel').each(function() {
        let $carousel = $(this);

        let hasNextSlide = !$carousel.find('.owl-nav .owl-next').hasClass('disabled');
        let hasPrevSlide = !$carousel.find('.owl-nav .owl-prev').hasClass('disabled');

        let $floatNav = $carousel.next('.float-nav');

        if (hasNextSlide) {
            $floatNav.find('.owl-next').removeAttr('disabled');
        } else {
            $floatNav.find('.owl-next').attr('disabled', 'disabled');

            $floatNav.find('.owl-next').css('display', 'none');
            $floatNav.find('.owl-prev').css('display', 'none');
        }

        if (hasPrevSlide) {
            $floatNav.find('.owl-prev').removeAttr('disabled');
        } else {
            $floatNav.find('.owl-prev').attr('disabled', 'disabled');
        }
    });
}

function productNav() {
    if ($('.product-nav').length) {
        let section = visiblePercent($('.product'));

        if (visiblePercent($('footer.footer')) > 0) {
            $('.product-nav').fadeOut();
        }
        else {
            if (section >= 100) {
                $('.product-nav').fadeIn();
            }
            else {
                $('.product-nav').fadeOut();
            }
        }
    }
}

function video_bg_text() {
    if ($('.video-bg-text').length) {
        $('.video-bg-text').each(function() {
            let video = $(this);
            let clip = visiblePercent(video) / 5;
        
            video.css('clip-path', `polygon(${20 - clip}% ${20 - clip}%, ${80 + clip}% ${20 - clip}%, ${80 + clip}% 100%, ${20 - clip}% 100%)`);
        
            if (visiblePercent(video) > 80) {
                video.find('.aos-init').addClass('aos-animate');
            } else {
                video.find('.aos-init').removeClass('aos-animate');
            }
        });        
    }
}

$('.product .main-slider .swiper-slide').on('click', function() {
    $('.mdl[data-mdl="media-gallery"]').fadeIn();

    $('body').css('overflow-y', 'hidden');
});

$('.product .size-fit-btn').on('click', function() {
    $('.mdl[data-mdl="size-fit"]').fadeIn();

    let width = $('.mdl[data-mdl="size-fit"] .mdl-wrapper').outerWidth();
    $('.mdl[data-mdl="size-fit"] .mdl-wrapper').css('left', `calc(100% - ${width}px)`);


    $('body').css('overflow-y', 'hidden');
});

$('[data-yt]').on('click', function() {
    let videoId = $(this).data('yt');

    let iframeUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    let iframe = `<iframe src="${iframeUrl}" frameborder="0" allowfullscreen></iframe>`;

    $('.mdl[data-mdl="youtube"] .youtube-wrapper').first().append(iframe);
    $('.mdl[data-mdl="youtube"]').first().fadeIn();

    $('body').css('overflow-y', 'hidden');

    if ($('.video-bg-text').length) {
        $('.video-bg-text video')[0].pause();
    }
});

$('.text-toggle-image .toggle').on('click', function() {
    const $container = $(this).closest('.text-toggle-image');
    const $imageWrapper = $container.find('.image-wrapper');
    const index = $(this).index();

    if ($(this).nextAll('.toggle').hasClass('active')) {
        $imageWrapper.find(`img:eq(${index})`)
            .addClass('active')
            .siblings()
            .removeClass('active');
    } else {
        $imageWrapper.find(`img:eq(${index})`).addClass('active');
    }

    $(this).addClass('active').siblings().removeClass('active');
});

$(document).on('click', '.nav a[data-anchor]', function() {
    let anchor = $(this).data('anchor');
    let targetSection = $(`[data-scrollspy="${anchor}"]`);
    
    if (targetSection.length) {
        $('html, body').animate({
            scrollTop: targetSection.offset().top
        }, 0);
    }
});

/* 已弃用
function block_text_image() {
    if ($('.block-text-image').length) {
        $('.block-text-image .wrapper').each(function() {
            if (visiblePercent($(this).find('.aos-init')) > 30) {
                $(this).find('.aos-init').addClass('aos-animate');
            }
            else {
                $(this).find('.aos-init').removeClass('aos-animate');
            }
        });
    }
}*/
function block_text_image() {
    if ($('.block-text-image').length) {
        $('.block-text-image .wrapper').each(function() {
            const $wrapper = $(this);
            const $aos = $wrapper.find('.aos-init');
            const $video = $wrapper.find('video.block-media');
            const isVisible = visiblePercent($aos.length ? $aos : $wrapper) > 30;

            if (isVisible) {
                $aos.addClass('aos-animate');

                if ($video.length) {
                    const video = $video[0];
                    const $source = $video.find('source[data-src]');

                    if ($source.length && !$source.attr('src')) {
                        $source.attr('src', $source.attr('data-src'));
                        video.load();
                    }

                    video.play().catch(function() {});
                }
            } else {
                $aos.removeClass('aos-animate');

                if ($video.length) {
                    $video[0].pause();
                }
            }
        });
    }
}

function image_hotspot() {
    if ($('.image-hotspot').length) {
        $('.image-hotspot').each(function() {
            if (visiblePercent($(this).find('img.aos-init')) > 10) {
                $(this).find('img.aos-init').addClass('aos-animate');
                setTimeout(() => {
                    $(this).find('.spot.aos-init').addClass('aos-animate');
                }, 500);
            }
        });
    }
}

function showHotspotData(element) {
    const yPosition = $(element).get(0).style.top;
    const xPosition = parseFloat($(element).get(0).style.left);
    const i = $(element).data('i');

    const hotspotDataHeight = $(`.hotspot-data[data-i="${i}"]`).outerHeight();
    const position = $(`.hotspot-data[data-i="${i}"]`).data('position');
    const spotHeight = $(element).outerHeight();

    if (wSize >= 1280) {
        if (position == 'bottom-left') {
            $(`.hotspot-data[data-i="${i}"]`).css({
                'top': `calc(-${hotspotDataHeight - spotHeight}px + ${yPosition})`,
                'left': 'auto',
                'right': `${100 - xPosition + 1}%`
            }).fadeIn().siblings('.hotspot-data').fadeOut();
        }
        if (position == 'bottom-right') {
            $(`.hotspot-data[data-i="${i}"]`).css({
                'top': `calc(-${hotspotDataHeight - spotHeight}px + ${yPosition})`,
                'right': 'auto',
                'left': `calc(${spotHeight}px + ${xPosition + 1}%)`
            }).fadeIn().siblings('.hotspot-data').fadeOut();
        }
        if (position == 'top-left') {
            $(`.hotspot-data[data-i="${i}"]`).css({
                'top': `${yPosition}`,
                'left': 'auto',
                'right': `${100 - xPosition + 1}%`
            }).fadeIn().siblings('.hotspot-data').fadeOut();
        }
        if (position == 'top-right') {
            $(`.hotspot-data[data-i="${i}"]`).css({
                'top': `${yPosition}`,
                'right': 'auto',
                'left': `calc(${spotHeight}px + ${xPosition + 1}%)`
            }).fadeIn().siblings('.hotspot-data').fadeOut();
        }
    } else {
        $(`.hotspot-data[data-i="${i}"]`).css({
            'top': '50%',
            'left': '50%',
            'right': '50%',
            'transform': 'translate(-50%, -50%)'
        }).fadeIn().siblings('.hotspot-data').fadeOut();
    }
}

function bindHotspotEvents() {
    $(document).off('mouseover', '.image-hotspot .spot');
    $(document).off('click', '.image-hotspot .spot');
    $(document).off('mouseleave', '.image-hotspot .spot');

    if (wSize >= 1280) {
        $(document).on('mouseover', '.image-hotspot .spot', function() {
            showHotspotData(this);
        });
    } else {
        $(document).on('click', '.image-hotspot .spot', function() {
            showHotspotData(this);
        });
    }

    $(document).on('mouseleave', '.image-hotspot .spot', function() {
        $('.hotspot-data').fadeOut();
    });
}

bindHotspotEvents();

function middle_banner() {
    if ($('.middle-banner').length) {
        $('.middle-banner').each(function() {
            if (visiblePercent($(this)) > 80) {
                $(this).find('.aos-init').addClass('aos-animate');
            }
        });        
    }
}

$(document).on('click', '.variant-option-block .variant-colors li', function() {
    $(this).addClass('on').siblings().removeClass('on');
    let colorId = $(this).data('color');

    $(`.product-image img[data-variant="${colorId}"]`).addClass('active').siblings().removeClass('active');
});

$('.faq-load').on('click', function() {
    $('.faq .accordion-item').fadeIn();
    $(this).hide();
});

function youtube_slider() {
    if ($('.youtube-slider').length) {
        let top = $('.youtube-slider .youtube').height()/2;

        $('.youtube-slider .float-nav').css('top', `${top}px`);
    }
}

$(document).on('click', '.product-card .product-image', function() {
    if (wSize >= 1280) {
        let link = $(this).data('link');
        if (link) {
            window.location.href = link;
        }
    }
});